export default {
  setInvoices(state, data) {
    state.invoices = data;
  },
  setInvoicesTotalCount(state, data) {
    state.invoicesTotalCount = data;
  },
  setKeys(state, data) {
    state.keys = data;
  },
};
